import { Node, mergeAttributes } from "@tiptap/core";

/**
 * Inline images.
 *
 * StarterKit does not include an image node, so an `<img>` is dropped on the
 * first save. The notices reach the editor with one whenever splitLetterhead
 * finds no letterhead to peel off - NoticePreview's `allowImages: headerInBody`
 * is exactly that case - and the factsheet carries signatures and seals.
 *
 * Attributes match the `img[src|alt|width|height]` entry in
 * NOTICE_VALID_ELEMENTS. Inline rather than block, because the stored markup
 * wraps images in paragraphs.
 */
export const ImageNode = Node.create({
  name: "image",

  inline: true,
  group: "inline",
  draggable: true,

  addAttributes() {
    return {
      src: { default: null },
      alt: { default: null },
      title: { default: null },
      width: { default: null },
      height: { default: null },
      style: { default: null },
    };
  },

  parseHTML() {
    return [{ tag: "img[src]" }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["img", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)];
  },
});

export default ImageNode;
